var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fb2d586b71fa6a200c4b55837c5f7e4e653a8865"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["appsmith@appsmith"]={id:"fb2d586b71fa6a200c4b55837c5f7e4e653a8865"};
      